<template>
  <div class="flex flex-col w-full mb-1">
    <data-field :label="$t('components.company.crm.keyEntered')">
      {{ onofficeConfig.token?.length > 0 ? $t('components.company.crm.yes') : $t('components.company.crm.no') }}
    </data-field>
    <data-field :label="$t('components.company.crm.keyValid')">
      {{ onofficeConfig.isTokenVerified ? $t('components.company.crm.yes') : $t('components.company.crm.no') }}
    </data-field>
    <data-field :label="$t('components.company.crm.selectedContactType')">
      {{ statuses }}
    </data-field>
  </div>
</template>

<script>
import ONOFFICE_CONFIG from '@/graphql/OnofficeConfig.gql'
import ONOFFICE_CONTACT_TYPES from '@/graphql/OnofficeContactTypes.gql'
import DataField from '@/components/data-field'

export default {
  components: {
    DataField
  },
  props: {
    companyId: { type: String, default: '' }
  },
  data () {
    return {
      onofficeConfig: { selectedContactTypes: [] },
      onofficeContactTypes: []
    }
  },
  computed: {
    statuses () {
      const onofficeContactTypesMap = new Map([
        ...this.onofficeContactTypes.map(status => [status.id, status.name]),
        ['ALL', this.$t('components.company.crm.allContacts')],
        ['UNDEFINED', this.$t('components.company.crm.contactsWithoutContactType')]
      ])
      return this.onofficeConfig.selectedContactTypes.map(id => onofficeContactTypesMap.get(id)).join(', ')
    }
  },
  apollo: {
    onofficeConfig: {
      query: ONOFFICE_CONFIG,
      variables () {
        return {
          companyId: this.companyId
        }
      }
    },
    onofficeContactTypes: {
      query: ONOFFICE_CONTACT_TYPES,
      variables () {
        return {
          companyId: this.companyId
        }
      }
    }
  }
}
</script>
